import { apiClient } from "@/lib/apiClient";

export const resaService = {
  async status() { return (await apiClient.get("/resa/status")).data; },
  async chat(payload) { return (await apiClient.post("/resa/chat", payload)).data; },
  async listConversations() { return (await apiClient.get("/resa/conversations")).data; },
  async getConversation(id) { return (await apiClient.get(`/resa/conversations/${id}`)).data; },
  async archiveConversation(id) { return (await apiClient.post(`/resa/conversations/${id}/archive`)).data; },
  async generateMarketing(payload) { return (await apiClient.post("/resa/marketing/generate", payload)).data; },
  async approveAction(id, edited_fields = null) { return (await apiClient.post(`/resa/actions/${id}/approve`, { edited_fields })).data; },
  async rejectAction(id) { return (await apiClient.post(`/resa/actions/${id}/reject`)).data; },
  async usage() { return (await apiClient.get("/resa/usage")).data; },
};
